import React, { useState, useEffect } from 'react';
import Topbar from './topBar';
import Sidebar from './sideBar';
import { deleteSurvey } from '../actions/adminAction';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { FiEye, FiTrash2, FiMapPin } from "react-icons/fi";
import { Tooltip } from 'react-tooltip';
import { Link, useNavigate } from 'react-router-dom'; // Import useNavigate
import { SURVEY } from '../constants/url';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import axios from 'axios';
import Cookies from 'universal-cookie';
import { API as url1 } from '../config';
const cookies = new Cookies();

const Survey = () => {
  const [values, setValues] = useState({
    data: '',
    orders: [],
    questions: false,
    qHeader: "View Questions",
    user: "All",
    users: ["All", "Farmer", "Organisation"],
    removed: false
  });
  const { orders, questions, user, users } = values;
  const [show, setShow] = useState(false);
  const [survey, setSurvey] = useState({});
  const [showDetails, setShowDetails] = useState(false);
  const navigate = useNavigate(); // Initialize useNavigate

  useEffect(() => {
    loadSurvey();
  }, []);

  const loadSurvey = () => {
    axios.get(`${url1}${SURVEY}/?token=${cookies.get("agritech_token")}&type=All`)
      .then(res => {
        setValues(prevState => ({
          ...prevState,
          orders: res.data.data
        }));
      })
      .catch(err => {
        console.error(err);
        alert(err);
      });
  };

  const handleChange = e => {
    e.persist();
    axios.get(`${url1}${SURVEY}/?token=${cookies.get("agritech_token")}&type=${e.target.value}`)
      .then(res => {
        setValues(prevState => ({
          ...prevState,
          orders: res.data.data,
          user: res.data.type
        }));
      })
      .catch(err => {
        console.error(err);
        alert(err);
      });
  };

  const handleClose = () => {
    setShow(false);
  };

  const deletea = (cell, row) => {
    const handleDelete = () => {
      Swal.fire({
        title: 'Are You Sure?',
        text: "",
        icon: 'error',
        showCancelButton: true,
        allowOutsideClick: true,
        confirmButtonText: 'Yes',
      }).then((result) => {
        if (result.isConfirmed) {
          deleteSurvey(row.id, cookies.get('agritech_token'))
            .then(data => {
              if (data.error) {
                console.log(data.error);
              } else {
                const updatedOrders = orders.filter(item => item.id !== row.id);
                setValues(prevState => ({
                  ...prevState,
                  orders: updatedOrders
                }));
                Swal.fire('Deleted!', 'Survey has been deleted.', 'success');
              }
            })
            .catch(error => {
              console.error('Delete Survey Error:', error);
              Swal.fire('Error', 'Failed to delete survey', 'error');
            });
        }
      });
    };

    const handleViewSurvey = () => {
      navigate(`/surveyQuestionnaire/${row.id}`); // Use navigate to navigate programmatically
    };

    return (
      <div className="d-flex align-items-center justify-content-center">
            <Link to={`/surveyQuestionnaire/${row.id}`}>
          <i className="mx-1 cursor-pointer " data-tooltip-id="1" data-tooltip-content="View" >
            <FiEye onClick={handleViewSurvey} color="#9368f3" size="20" />
          </i>
        </Link>
        {/* {row.treelocation !== "" ? (
          <a id="data" href={`https://maps.google.com?q=${row.latitude},${row.longitude}`} target="_blank" rel="noopener noreferrer">
            <i className="mx-1 cursor-pointer " data-tooltip-id="3" data-tooltip-content="Tree Location">
              <FiMapPin color="#ff9800" size="20" />
            </i>
          </a>
        ) : null} */}
        <i className="mx-1 cursor-pointer " data-tooltip-id="4" data-tooltip-content="Delete">
          <FiTrash2 onClick={handleDelete} color="red" size="20" />
        </i>
        <Tooltip id="1" />
        <Tooltip id="2" />
        <Tooltip id="3" />
        <Tooltip id="4" />
      </div>
    );
  };

  return (
    <div id="wrapper">
      <Topbar backgroundColor='#769A0F' />
      <Sidebar />
      <div className="content-page">
        <div className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box">
                  <h4 className="page-title float-left">Survey</h4>
                  <ol className="breadcrumb float-right">
                    <li className="breadcrumb-item">
                      <Link to='/dashboard'>Dashboard</Link>
                    </li>
                    <li className="breadcrumb-item active">Survey</li>
                  </ol>
                  <div className="clearfix"></div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card-box">
                  {questions === true && (
                    <div className="row">
                      <div className="col-md-6">
                        <div>
                          <link href="https://getbootstrap.com/docs/4.0/dist/css/bootstrap.min.css" rel="stylesheet" />
                          <div className="container"></div>
                          <p><span className="Apple-converted-space">&nbsp;&nbsp; </span><strong>English</strong></p>
                          <ol>
                            <li>Do you have Jackfruit ?<span className="Apple-converted-space">&nbsp;</span></li>
                          </ol>
                          <p>Answer: Yes or No<span className="Apple-converted-space">&nbsp;</span></p>
                          <ol start="2">
                            <li>Are you willing to make income from jackfruit?<span className="Apple-converted-space"></span></li>
                          </ol>
                          <p>Answer: Yes or No<span className="Apple-converted-space"></span></p>
                          <ol start="3">
                            <li>How many Jack Trees are there? Give number typing option.<span className="Apple-converted-space">&nbsp;</span></li>
                          </ol>
                          <ol>
                            <p>3a. How many Koozha Plavu? <span className="Apple-converted-space">&nbsp;</span>3b. How Many Varikka Plavu?</p>
                          </ol>
                          <ol start="4">
                            <li>What are the types of Jack trees available in your property?</li>
                          </ol>
                          <p>Options:</p>
                          <p>Muttom Varikka</p>
                          <p>Singapore jack or Ceylon jack</p>
                          <p>Thenvarikka</p>
                          <p>Sindhoor</p>
                          <p>Vietnam Super Early</p>
                          <p>Ayur jack</p>
                          <p>Others (Enter manually)</p>
                          <ol start="5">
                            <li>What is the usual harvesting time for your Jack Tree?<span className="Apple-converted-space"></span></li>
                          </ol>
                          <p>Date (from to to)<span className="Apple-converted-space">&nbsp;</span></p>
                          <p>Answer: Yes or No</p>
                          <ol start="9">
                            <li>Are you willing to provide Jackfruit at farm gate price?</li>
                          </ol>
                          <p>Answer: Yes or No</p>
                        </div>
                      </div>
                    </div>
                  )}
                  <TableContainer>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell width='80px' align="center">S.No</TableCell>
                          <TableCell width='180px' align="center">Surveyor</TableCell>
                          <TableCell width='180px' align="center">Designation</TableCell>
                          <TableCell width='180px' align="center">Address</TableCell>
                          <TableCell width='180px' align="center">Mobile</TableCell>
                          <TableCell width='180px' align="center">Actions</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {orders && orders.length > 0 ? (
                          orders.map((row, index) => (
                            <TableRow key={index}>
                              <TableCell align="center">{index + 1}</TableCell>
                              <TableCell align="center">{row.name}</TableCell>
                              <TableCell align="center">{row.designation}</TableCell>
                              <TableCell align="center">{row.address}</TableCell>
                              <TableCell align="center">{row.mobile_no}</TableCell>
                              <TableCell align="center">{deletea(null, row)}</TableCell>
                            </TableRow>
                          ))
                        ) : (
                          <TableRow>
                            <TableCell colSpan={6} align="center">No data available</TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Survey;
